// extracted by mini-css-extract-plugin
export default {"backdrop":"Popup_backdrop__GsVg9","popup":"Popup_popup__DDMD3","title":"Popup_title__53Wuz"};